var map = {
	"./breakfast-no-menu.svg": "nF4j",
	"./dinner-no-menu.svg": "lXzQ",
	"./donut-fail.svg": "ZNYj",
	"./donut-success.svg": "tawm",
	"./grill.svg": "UfMd",
	"./light.svg": "wOw1",
	"./missing-food.svg": "mvpk",
	"./qr-code.svg": "1IFs",
	"./regular.svg": "d0k5",
	"./vegan.svg": "7FRZ",
	"./vegetarian.svg": "6cWW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5lmF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*\.svg$
// module id = 5lmF
// module chunks = 1